import React from 'react';
import { Text, TextProps, StyleSheet } from 'react-native';

type TextWrapperProps = TextProps & {
  children: React.ReactNode;
};

export const TextWrapper = ({ children, style, ...rest }: TextWrapperProps) => {
  return (
    <Text style={[styles.text, style]} {...rest}>
      {children}
    </Text>
  );
};

const styles = StyleSheet.create({
  text: {
    fontFamily: 'OpenSans',
  },
});
